import cs from 'classnames';
import { Button } from 'components/atoms';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold } from 'react-icons/pi';
import { IChildrenProp } from 'types/components/components.interface';
import './ContractSideMenuWrapper.scss';

interface IContractSideMenuWrapperProps extends IChildrenProp {
  header?: React.ReactNode;
}

const ContractSideMenuWrapper = ({
  children,
  header,
}: IContractSideMenuWrapperProps) => {
  const { values, setFieldValue, hideContract } = useFormikContractHelpers();
  const { t } = useTranslation();

  const hideDetailPage = () => {
    setFieldValue('sideMenu.displayed', false);
  };

  const classes = cs(['contract-side-menu-wrapper'], {
    'side-menu-displayed': !!values.sideMenu?.displayed,
  });

  return (
    <div className={classes}>
      {!hideContract && (
        <div className='contract-side-menu-header'>
          <Button
            onlyIcon
            isClear
            onClick={hideDetailPage}
            disabled={hideContract}>
            <Button.Description description={t('button.back')} />
            <Button.Icon icon={<PiCaretLeftBold />} />
          </Button>
          {header}
        </div>
      )}
      <div className='contract-side-menu-content'>{children}</div>
    </div>
  );
};

export default ContractSideMenuWrapper;
